module.exports = __webpack_public_path__ + "static/media/Balzam_na_rty_Omega369_retina.591e30cc.jpg";